function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Setting",
  transform: "translate(0.112 -0.028)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_33946",
  d: "M19.709,6.011l-.7-1.214A2.151,2.151,0,0,0,16.076,4h0a3.927,3.927,0,0,1-1.625.228,2.141,2.141,0,0,1-1.309-.989,2.058,2.058,0,0,1-.288-1.029h0A2.151,2.151,0,0,0,10.7,0H9.293A2.141,2.141,0,0,0,7.152,2.151h0A2.151,2.151,0,0,1,5,4.271a2.058,2.058,0,0,1-1.029-.288h0a2.151,2.151,0,0,0-2.933.792L.288,6.011A2.151,2.151,0,0,0,1.07,8.944h0a2.151,2.151,0,0,1,1.076,1.863A2.151,2.151,0,0,1,1.07,12.67h0a2.141,2.141,0,0,0-.782,2.923h0L1,16.817a2.151,2.151,0,0,0,2.933.834h0a2.13,2.13,0,0,1,2.923.782,2.058,2.058,0,0,1,.288,1.029h0a2.151,2.151,0,0,0,2.151,2.151H10.7a2.151,2.151,0,0,0,2.151-2.141h0a2.141,2.141,0,0,1,2.151-2.151,2.192,2.192,0,0,1,1.029.288h0a2.151,2.151,0,0,0,2.933-.782h0l.741-1.235a2.141,2.141,0,0,0-.782-2.933h0a2.141,2.141,0,0,1-.782-2.933,2.11,2.11,0,0,1,.782-.782h0a2.151,2.151,0,0,0,.782-2.923h0Z",
  transform: "translate(0.779 0.778)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}), /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_737",
  cx: 2.964,
  cy: 2.964,
  r: 2.964,
  transform: "translate(7.818 8.621)",
  fill: "none",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5
}));

function SvgActiveSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.769,
    height: 23.114,
    viewBox: "0 0 21.769 23.114",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveSettings);
export default __webpack_public_path__ + "static/media/ActiveSettings.165fe860.svg";
export { ForwardRef as ReactComponent };